import { Tooltip as O } from '../../node_modules/react-tooltip/dist/react-tooltip.min.mjs.js';
import styled, { css } from 'styled-components';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';
import 'react';

const focus = (props) => css `
  box-shadow: 0 0 0 2px
    ${props.theme.colors.content[mapBackgroundToContentColor({
    backgroundColor: props.backgroundColor,
    theme: props.theme,
})]};
  outline: transparent solid 2px;
`;
const TooltippedElementWrapper = styled.div `
  position: relative;
  overflow: visible;
  transition-duration: 0.05s;
  width: ${props => (props.width ? props.width : 'fit-content')};

  &:focus {
    ${props => focus(props)}
  }
`;
const TooltipWrapper = styled.div `
  width: ${props => (props.width ? props.width : 'auto')};
`;
const ReactTooltipContent = styled(O) `
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  border-radius: ${props => props.theme.borderRadii.small};
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  font-family: ${props => props.theme.fontFamilies.main[props.fontFamily]};
  font-size: ${props => props.theme.fontSizes[props.fontSize]};
  line-height: ${props => props.theme.lineHeights.large};
  max-width: ${props => props.maxTooltipWidth ? `${props.maxTooltipWidth}px` : '350px'};
  padding: 8px;
  transition: opacity 0.04s;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  opacity: 1;
  z-index: 999;
`;

export { ReactTooltipContent, TooltipWrapper, TooltippedElementWrapper };
